import getCoverArtUrl from './getCoverArtUrl';

/* eslint-disable camelcase */
export default ({
  is_active,
  name,
  caption,
  is_locale_master,
  video,
  video_file_name,
  cover_art,
  author,
  published_at,
  code,
  credit_units,
  locale,
  community_enabled,
  tribe_chat_enabled,
  customFields,
  exclude_from_search,
  summary,
  tags,
  seo_title,
  seo_description,
  url_slug,
  robots_meta_tags,
  topics,
  topic,
  invitation_email,
  letter_triggers,
  allow_public_view,
  status,
  enrollment_url,
  attendance_max,
  enforce_attendance_max,
  has_waitlist,
  waitlist_max,
}) => ({
  general: {
    is_active,
    name,
    caption,
    is_locale_master,
    status,
  },
  video_trailer: {
    video,
    video_file_name,
  },
  display: {
    cover_art: getCoverArtUrl(cover_art),
  },
  additional_details: {
    author,
    published_at,
    code,
    credit_units,
    locale,
  },
  social: {
    community_enabled,
    tribe_chat_enabled
  },
  custom_fields: {
    ...customFields,
  },
  catalog: {
    exclude_from_search,
    topic,
    summary,
  },
  public_properties: {
    allow_public_view
  },
  tagging: {
    tags,
  },
  seo_properties: {
    seo_title,
    seo_description,
    url_slug,
    robots_meta_tags,
  },
  topics,
  advanced_properties: {
    invitation_email,
    letter_triggers,
  },
  enrollment: {
    enrollment_url,
    attendance_max,
    enforce_attendance_max,
    has_waitlist,
    waitlist_max,
  },
});
